module.exports = __webpack_public_path__ + "img/firestone4.fdac85f9.png";